export default __webpack_public_path__ + "static/media/partner-offer-cover-image.940666f2.png";